/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetExchangeRatesRow } from '../openapi-types.gen.js';
import { type useGetExchangeRatesArgs, useGetExchangeRatesSpec } from '../specs/exchange-rates.spec.gen.js';

export type { GetExchangeRatesRow } from '../openapi-types.gen.js';
export type { useGetExchangeRatesArgs } from '../specs/exchange-rates.spec.gen.js';


export const useGetExchangeRates = createHook(useGetExchangeRatesSpec);


/**
 * Hover/intent prefetch companion for `useGetExchangeRates`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetExchangeRates();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetExchangeRates = createPrefetchHook(useGetExchangeRatesSpec);
